import { createContext, useContext } from "react";

export type ShortcutsApi = { show: () => void };

export const ShortcutsContext = createContext<ShortcutsApi>({ show: () => undefined });

/** Opens the "?" sheet from anywhere under the shell (the Help page uses it). */
export function useShortcuts(): ShortcutsApi {
  return useContext(ShortcutsContext);
}
